import React, { FC } from 'react';
import { Image } from 'react-native';

import { Theme } from '@constants';
import { MoonIconCode } from '@types';

import { MOON_ICON_MAP } from '../../../assets/icons/moon/moon_icon_map';
import { MOON_ICON_PATH_MAP } from '../../../assets/icons/moon/moon_icon_path_map';

export const TWCMoonIcon: FC<TWCMoonIconProps> = ({ code, height = 50, width = 50 }) => {
  const iconPath = MOON_ICON_PATH_MAP[MOON_ICON_MAP[code]];

  return (
    <Image
      accessibilityIgnoresInvertColors
      source={iconPath}
      style={{ height: Theme.px(height), width: Theme.px(width) }}
    />
  );
};

type TWCMoonIconProps = {
  code: MoonIconCode;
  height: number;
  width: number;
};
